module.exports = __webpack_public_path__ + "img/dangdang.1b9e210b.png";